import classNames from "classnames";
import { FC, useMemo } from "react";

import Modal from "components/Modal";
import CreateAssetContent from "./Content";

import { AssetFormValues } from "entities/common";
import { getModalCallbacks } from "store/slices/modalCallbacksRegistry";

import styles from "./style.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  mode?: "create" | "edit";
  id?: number;
  initialData?: AssetFormValues;
  callbackKey?: string;
  companyId?: number;
};

const WidgetModalCreateAsset: FC<PropTypes> = ({
  isVisible,
  className,
  mode = "create",
  id,
  initialData,
  callbackKey,
  companyId,
}) => {
  const callbacks = useMemo(() => (callbackKey ? getModalCallbacks(callbackKey) : undefined), [callbackKey]);
  const onSubmit = useMemo(() => callbacks?.onSave, [callbacks]);

  const isCreate = mode === "create";
  const title = isCreate ? "Create new asset" : "Edit asset";
  const description = isCreate ? "Add a new asset to your portfolio" : "Update asset information";

  return (
    <Modal title={title} isClose isCloseBg isVisible={isVisible} className={classNames(styles.modal, className)}>
      <CreateAssetContent
        description={description}
        id={id}
        mode={mode}
        initialData={initialData}
        companyId={companyId}
        onSubmit={onSubmit}
      />
    </Modal>
  );
};

export default WidgetModalCreateAsset;
